module.exports = __webpack_public_path__ + "img/reset.e489abf7.png";